import type { HelpContent } from '../types'

/** Help panel + first-run walkthrough copy for the Content section. Em-dash free. */
export const CONTENT_HELP: HelpContent = {
  key: 'content',
  title: 'Content',
  intro:
    'Content is where you draft, schedule, and publish LinkedIn posts. AI writes a first draft from your topic; you review it, then publish now or schedule it. Content is a Pro feature and needs a connected LinkedIn account.',
  panel: [
    {
      heading: 'How it works',
      items: [
        { text: 'Click Generate Post, pick a topic, format, and tone, and AI drafts a post.' },
        { text: 'A generated post is a draft. It does not publish on its own unless you turn on Schedule.' },
        { text: 'Review a draft, then Publish Now or Schedule it for later.' },
      ],
    },
    {
      heading: 'Post statuses',
      items: [
        { term: 'Draft', text: 'Saved, not scheduled or live.' },
        { term: 'Pending Review', text: 'An AI draft waiting for your approval.' },
        { term: 'Approved', text: 'You okayed it. Publish or schedule it next.' },
        { term: 'Scheduled', text: 'Queued to publish automatically at a set time.' },
        { term: 'Published', text: 'Live on your LinkedIn feed.' },
      ],
    },
    {
      heading: 'The three views',
      items: [
        { term: 'Posts', text: 'All your posts as cards you can filter and act on.' },
        { term: 'Calendar', text: 'Your posts laid out by date. The dot colors match the statuses above.' },
        { term: 'Engagement', text: 'People who liked or commented on your posts. Interested ones can become leads.' },
      ],
    },
    {
      heading: 'Good to know',
      items: [
        { text: 'Publishing needs a connected LinkedIn account.' },
        { text: 'The editor flags issues, like an unfilled placeholder, that you must fix before approving.' },
      ],
    },
  ],
  tour: [
    {
      id: 'welcome',
      title: 'Your content workspace',
      body: 'Draft, schedule, and publish LinkedIn posts. AI writes the first draft and you approve it.',
    },
    {
      id: 'generate',
      target: 'content-generate',
      title: 'Draft a post',
      body: 'Pick a topic, format, and tone, and AI drafts a post for you to review.',
    },
    {
      id: 'stats',
      target: 'content-stats',
      title: 'Your content at a glance',
      body: 'Total posts, what published this week, drafts pending your review, and what is scheduled.',
    },
    {
      id: 'views',
      target: 'content-views',
      title: 'Three ways to work',
      body: 'Browse posts, see them on a calendar, or view who engaged with them.',
    },
    {
      id: 'done',
      title: 'One thing to remember',
      body: 'A generated post stays a draft unless you schedule or publish it. Reopen this from Help anytime.',
    },
  ],
}
